<template>
  <div>
    <el-dialog title="修改菜单" :visible.sync="dialogVisible" width="450px">
      <el-form class="post-main-container post-dialog-container" label-position="right">
        <el-form-item label="菜单：" prop="permission">
          <el-select
            v-model="authList"
            multiple
            collapse-tags
            placeholder="请选择"
            style="width: 240px"
          >
            <el-option-group
              v-for="group in authTree"
              :key="group.id"
              :label="group.meta ? group.meta.title : group.children[0]['meta']['title']"
            >
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.meta.title || ''"
                :value="item.id"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateAuth" :loading="btnLoading">提交</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateRoleMenu } from '@/api/admin'

export default {
  props: {
    authTree: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      dialogVisible: false,
      btnLoading: false,

      authList: [],
      temp: {
        id: ''
      }
    }
  },

  methods: {
    handleUpdate(row) {
      console.log('row----- :>> ', row, row.code)
      this.temp.id = row.code
      this.authList = row.menus

      this.dialogVisible = true
    },

    updateAuth() {
      this.btnLoading = true
      console.log('object :>> ', this.temp)
      const data = {
        roleId: this.temp.id,
        ids: this.authList.join(',')
      }
      console.log('data :>> ', data)
      updateRoleMenu(data)
        .then(() => {
          this.btnLoading = false
          this.dialogVisible = false

          this.$message.success('提交角色菜单成功')
          this.$emit('listenPostSuccess')
        })
        .catch(() => {
          this.btnLoading = false
        })
    }
  }
}
</script>
